import { useState } from 'react';

import { DeveloperCard } from './DeveloperCard';
import { FeatureFlags } from './FeatureFlags/FeatureFlags';

type DeveloperTools = 'featureFlags';

export const AllDeveloperCards = () => {
  const [activeTool, setActiveTool] = useState<DeveloperTools | null>(null);

  if (activeTool === 'featureFlags') {
    return <FeatureFlags setActiveTool={setActiveTool} />;
  }

  return (
    <div className="flex flex-wrap gap-6">
      <DeveloperCard
        icon="tag-01"
        onClick={() => {
          setActiveTool('featureFlags');
        }}
        title="Manage feature flags"
      />
    </div>
  );
};
